import { FC } from "react";

const StepVerticalDivider: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2"
    height="33"
    viewBox="0 0 2 33"
    fill="none"
  >
    <path d="M1 0.0834968L1 32.0835" stroke="#747981" strokeDasharray="2 2" />
  </svg>
);

export default StepVerticalDivider;
